const baseReportUrl = "Report"



  const endpoints = {
    getCategoryBasedAdvertCounts:`${baseReportUrl}/CategoryBasedAdvertCounts`,
    getAdvertDurationStats:`${baseReportUrl}/AdvertDurationStats`,
    getAdvertDuration30Day:`${baseReportUrl}/AdvertDuration30Day`,
    getMessageResponseTime:`${baseReportUrl}/MessageResponseTime`,
    getUnansweredMessages:`${baseReportUrl}/UnansweredMessages`,
    
  };
  
  export default endpoints;
  